<template>
	<div>
		<!-- basic search -->
		<a-row type="flex" class="mt-3">
			<a-col :span="10">
				<span class="font-weight-bold text-dark font-size-18 text-nowrap"
					>RESULT
				</span>
				<span class="air__utils__link">{{ getPostsTotalCount }}</span>
				<span class="text-lowercase"> post matching criteria </span>
			</a-col>
			<a-col :span="14">
				<div class="d-flex">
					<a-button
						:type="showFilter ? 'primary' : 'default'"
						class="ml-auto mr-1"
						@click="handleFilter"
					>
						<a-icon type="filter" />
					</a-button>

					<a-select
						v-model="filterOrder"
						class="mr-1 width-150"
						@change="handleOrder"
					>
						<a-select-option value="likes">
							Likes
						</a-select-option>
						<a-select-option value="comments">
							Comments
						</a-select-option>
						<a-select-option value="views">
							Views
						</a-select-option>
						<a-select-option value="engagement">
							Engagement
						</a-select-option>
						<a-select-option value="date">
							Fecha
						</a-select-option>
					</a-select>

					<a-radio-group
						v-model="fitlerDirection"
						button-style="solid"
						class="mr-4"
						@change="handleDirection"
					>
						<a-radio-button value="asc" block>
							<a-icon type="arrow-up" />
						</a-radio-button>
						<a-radio-button value="desc">
							<a-icon type="arrow-down" />
						</a-radio-button>
					</a-radio-group>
					<a-button
						type="default"
						@click="handleSearch"
						:loading="filterLoading"
					>
						Buscar
					</a-button>
				</div>
			</a-col>
		</a-row>
		<!-- advance search -->
		<a-row type="flex" align="middle" v-if="showFilter" class="mt-3">
			<a-col :span="24">
				<div class="card air__utils__shadow">
					<div class="card-body">
						<div class="row">
							<div class="col-lg-3">
								<div class="mb-2">
									<div class="text-dark">Category A</div>
									<a-select style="width: 100%;" v-model="filterCategoryA">
										<a-select-option :value="0">
											Seleccione...
										</a-select-option>
										<a-select-option
											v-for="(category, index) in categoryA"
											:value="category.id"
											:key="index"
										>
											{{ category.code }}
										</a-select-option>
									</a-select>
								</div>
								<div class="mb-2">
									<div class="text-dark">Category B</div>
									<a-select
										default-value="Seleccione..."
										style="width: 100%;"
										v-model="filterCategoryB"
									>
										<a-select-option :value="0">
											Seleccione...
										</a-select-option>
										<a-select-option
											v-for="(category, index) in categoryB"
											:value="category.id"
											:key="index"
										>
											{{ category.code }}
										</a-select-option>
									</a-select>
								</div>
							</div>

							<div class="col-lg-3">
								<div class="mb-2">
									<div class="text-dark">Desde</div>
									<a-date-picker
										v-model="fitlerDateFrom"
										format="DD/MM/YYYY"
										:defaultValue="fitlerDateFrom"
										:disabled-date="disableStartDateBiggerThanEnd"
									/>
								</div>
								<div class="mb-2">
									<div class="text-dark">Hasta</div>
									<a-date-picker
										v-model="fitlerDateEnd"
										format="DD/MM/YYYY"
										:defaultValue="fitlerDateEnd"
										:disabled-date="disableDateMoreThanToday"
										@change="handleEndDate"
									/>
								</div>
							</div>
							<div class="col-lg-3">
								<div class="mb-2">
									<div class="text-dark">Tipo de Contenido</div>
									<a-select v-model="fitlerContent" style="width: 100%;">
										<a-select-option value="all">
											Todo
										</a-select-option>
										<a-select-option value="images">
											Imagenes
										</a-select-option>
										<a-select-option value="videos">
											Videos
										</a-select-option>
										<a-select-option value="igtv">
											IGTV
										</a-select-option>
										<a-select-option value="reels">
											Reels
										</a-select-option>
									</a-select>
								</div>
							</div>
							<div class="col-lg-3">
								<div class="mb-2">
									<div class="text-dark">Mention</div>
									<a-select
										mode="tags"
										style="width: 100%;margin-bottom:20px;"
										:token-separators="[',']"
										ref="userNameInput"
										v-model="filterMention"
										addon-before="@"
									>
									</a-select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</a-col>
		</a-row>

		<!-- loading post -->
		<a-row>
			<a-col :span="24">
				<is-loading :isLoading="loadingResults" />
			</a-col>
		</a-row>
		<a-row class="mb-3" v-if="!loadingResults" :gutter="[24, 16]">
			<a-col
				:xs="24"
				:sm="8"
				:md="8"
				:lg="4"
				:order="key"
				v-for="(p, key) in getPosts"
				:key="key"
			>
				<a-row>
					<a-col :span="24">
						<a-tooltip placement="bottom">
							<template slot="title">
								<div>
									<div class="d-flex">
										<span class="font-weight-bold mr-1">Mention: </span>
										<span>{{ p.mention }}</span>
									</div>
									<div class="d-flex">
										<span class="font-weight-bold mr-1">Hashtag: </span>
										<span>{{ p.hashtag }}</span>
									</div>
								</div>
							</template>
							<div :class="[$style.holder, p.deleted ? $style.deleted : '']">
								<ImageModal :post="p" />
							</div>
						</a-tooltip>
					</a-col>
				</a-row>

				<div>
					<div class="d-flex flex-wrap">
						<span class="font-weight-bold">Fecha</span>
						<span class="ml-auto">{{
							moment(p.createdAt)
								.utc()
								.format('DD/MM/YYYY')
						}}</span>
					</div>
					<div class="d-flex">
						<span class="font-weight-bold">Views</span>
						<span class="ml-auto">{{ p.views }}</span>
					</div>
					<div class="d-flex">
						<span class="font-weight-bold">Likes</span>
						<span class="ml-auto">{{ p.likes }}</span>
					</div>
					<div class="d-flex">
						<span class="font-weight-bold">Comments</span>
						<span class="ml-auto">{{ p.comments }}</span>
					</div>
					<div class="d-flex">
						<span class="font-weight-bold">Engagement</span>
						<span class="ml-auto">{{ p.engagement }}</span>
					</div>
					<div class="d-flex" v-if="p.networkId === 5">
						<span class="font-weight-bold">Shares</span>
						<span class="ml-auto">{{ p.shares }}</span>
					</div>
				</div>
				<div class="text-gray-6">
					<div class="mt-3">
						<post-category
							:categoryA="categoryA"
							:categoryB="categoryB"
							:post="p"
						/>
						<router-link :to="'/post/' + p.id">
							<a-button block class="btn btn-light text-blue">
								Ver
							</a-button>
						</router-link>
					</div>
				</div>
			</a-col>
		</a-row>

		<a-row type="flex" justify="center">
			<a-col v-if="loadinMorePost">
				<IsLoading :isLoading="loadinMorePost" />
			</a-col>

			<a-col>
				<div
					v-if="
						!loadinMorePost && getPostsTotalCount > createFilter.offset + 24
					"
				>
					<a-button type="link" @click="loadMorePost">more...</a-button>
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
import IsLoading from '../../widgets/loading'
import ImageModal from '../../widgets/Detail/ImageModal'
import PostCategory from '@/components/widgets/Post/Categories'

import * as ACTIONS from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
	name: 'DetailSearch',
	components: {
		IsLoading,
		ImageModal,
		PostCategory,
	},
	props: {
		detailId: {
			type: Number,
			required: true,
		},
	},
	data: function() {
		return {
			moment,

			showFilter: false,
			fitlerDateFrom: moment()
				.utc()
				.subtract(20, 'days'),
			fitlerDateEnd: moment().utc(),
			fitlerContent: 'all',
			filterOrder: 'date',
			fitlerDirection: 'desc',
			filterMention: [],
			// Categories
			filterCategoryA: 0,
			filterCategoryB: 0,
			categoryA: [],
			categoryB: [],
			// other
			filterLoading: false,
			loadingResults: false,
			loadinMorePost: false,

			offset: 0,
		}
	},
	created() {
		let filter = this.createFilter
		this.loadingResults = true
		this.loadPosts({ filter: filter }).then(res => {
			this.loadingResults = false
		})
		this.countPosts({
			where: filter.where,
		}).then(res => {
			this.loadingPostCount = false
		})
		// Categories
		this.loadCategories().then(res => {
			this.categoryA = res.main
			this.categoryB = res.sub
		})
	},
	methods: {
		handleFilter() {
			this.showFilter = !this.showFilter
		},
		handleOrder(order) {
			this.filterOrder = order
			this.offset = 0
		},
		handleDirection(dir) {
			this.fitlerDirection = dir.target.value
			this.offset = 0
		},
		handleSearch() {
			let filter = this.createFilter
			this.filterLoading = true
			this.loadingResults = true
			this.offset = 0
			this.loadPosts({ filter: filter }).then(res => {
				this.loadingResults = false
				this.filterLoading = false
			})
			this.countPosts({
				where: filter.where,
			})
		},
		handleEndDate(current) {
			if (current < this.fitlerDateFrom) {
				this.fitlerDateFrom = current
			}
		},
		disableDateMoreThanToday(current) {
			return this.fitlerDateFrom > moment().utc()
		},
		disableStartDateBiggerThanEnd(current) {
			return current >= this.fitlerDateEnd
		},
		loadMorePost() {
			this.offset += 24
			let filter = this.createFilter
			this.loadinMorePost = true
			this.loadPosts({ filter: filter, append: true }).then(res => {
				this.loadinMorePost = false
			})
		},
		...mapActions({
			// posts
			loadPosts: ACTIONS.POST.BY_DETAIL_ID,
			countPosts: ACTIONS.POST.COUNT,
			// categories
			loadCategories: ACTIONS.CATEGORY.LIST,
		}),
	},
	computed: {
		createFilter() {
			let where = {
				detailId: this.detailId,
				and: [{ or: [] }, { createdAt: '' }],
			}
			if (this.filterMention !== null && this.filterMention.length > 0) {
				let or = this.filterMention.map(e => {
					return { mention: { like: '%' + e + '%' } }
				})
				where.and[0].or = or
			}
			where.and[1].createdAt = {
				between: [
					this.fitlerDateFrom.startOf('day'),
					this.fitlerDateEnd.endOf('day'),
				],
			}
			if (this.filterCategoryA !== 0) {
				where['categoryAId'] = { eq: this.filterCategoryA }
			}

			if (this.filterCategoryB !== 0) {
				where['categoryBId'] = { eq: this.filterCategoryB }
			}
			if (this.fitlerContent === 'videos') {
				where['isVideo'] = 1
			} else if (this.fitlerContent === 'images') {
				where['isVideo'] = 0
			} else if (this.fitlerContent === 'igtv') {
				where['typeId'] = 2
			} else if (this.fitlerContent === 'reels') {
				where['typeId'] = 3
			}
			let orderBy = 'likes'

			if (this.filterOrder === 'likes') {
				orderBy = 'likes'
			} else if (this.filterOrder === 'comments') {
				orderBy = 'comments'
			} else if (this.filterOrder === 'views') {
				orderBy = 'views'
			} else if (this.filterOrder === 'engagement') {
				orderBy = 'engagement'
			} else if (this.filterOrder === 'date') {
				orderBy = 'createdAt'
			}

			let orderDir = this.fitlerDirection
			let order = [orderBy + ' ' + orderDir]

			return {
				where: where,
				order: order,
				limit: 24,
				offset: this.offset,
			}
		},

		...mapGetters(['getPosts', 'getPostsTotalCount', 'getCurrentUser']),
	},
}
</script>

<style lang="scss" module>
@import './search.style.module.scss';
</style>
